import React, { useState } from "react";
import { motion } from "framer-motion";
import { Eye,  } from "lucide-react"; // Using Lucide icons
import { useGlobalContext } from "../../context";
import {
  tabsContent,
  projectsContent,
  mobileProjectsContent,
} from "../../data/works";
import { Loader } from "../tools/Loader";

import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { LayoutContainer } from "../common";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "../ui";


const AndroidIcon = ({ size = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    viewBox="0 0 24 24"
    width={size}
    height={size}
  >
    <path d="M16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
    <path d="M8 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
    <path d="M16 4h2a4 4 0 0 1 4 4v2a2 2 0 0 1-2 2h-2v-4ZM8 4H6a4 4 0 0 0-4 4v2a2 2 0 0 0 2 2h2v-4Z" />
    <path d="M12 2v6" />
    <path d="M2.5 12A10.5 10.5 0 0 0 12 22a10.5 10.5 0 0 0 9.5-10" />
    <path d="M12 2a5 5 0 0 0-5 5v5a7 7 0 0 0 7 7h0a7 7 0 0 0 7-7V7a5 5 0 0 0-5-5Z" />
  </svg>
);

const AppleIcon = ({ size = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    viewBox="0 0 24 24"
    width={size}
    height={size}
  >
    <path d="M12 20c-1.5-1-3-2.5-3-5a4 4 0 0 1 4-4c1.5 0 3 1 4 2.5a5 5 0 0 1 0 5c-1 1.5-2.5 2.5-4 2.5m-2-12a2 2 0 0 1 2-2c.5 0 1 0 1.5.5s1 1.5.5 2.5c-.5 1-1.5 1-2 1a2 2 0 0 1-2-2m-2 4a3 3 0 0 1 3-3c1 0 2 1 3 2.5s2 3 3 3.5a3 3 0 0 0 3-3c.5-1.5 0-3-1.5-4a5 5 0 0 0-3-1c-1.5 0-2 1-3.5 1.5C9 10 7 11 6 12.5c-1 1.5-1 3.5 0 5a5 5 0 0 0 5 1.5c1 0 2-1 3-2.5a5 5 0 0 0 0-5" />
  </svg>
);

const WebIcon = ({ size = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    viewBox="0 0 24 24"
    width={size}
    height={size}
  >
    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-15a9 9 0 0 1 8 5m-16 0a9 9 0 0 1 8-5M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2Z" />
    <path d="M2 12h20" />
  </svg>
);

const icons = {
  android: <AndroidIcon size={22} />,
  ios: <AppleIcon size={22} />,
  web: <WebIcon size={22} />,
}


export const Works = () => {
  const { t } = useGlobalContext();
  const [selectedItem, setSelectedItem] = useState(0);

  return (
    <LayoutContainer className="min-h-[83vh] flex-1 overflow-y-auto">
      <section className="container py-8">
        {/* Section Title */}

        <div className="flex items-center gap-4 pb-4">
          <h2 className="text-2xl font-bold text-primary">
            {t("works.title")}
          </h2>
        </div>
        {/* Tabs Component */}
        {/* <Tabs defaultValue="web" className="w-full  gap-6">
          <TabsList className="flex justify-center w-full space-x-4 h-12">
            {tabsContent.map((tab) => (
              <TabsTrigger
                key={tab.id}
                value={tab.id === 0 ? "web" : "mobile"}
                className="w-full flex items-center justify-center gap-2 py-2 text-lg font-medium rounded-md
                              data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:h-8
              "
              >
                {tab.icon}
                {t(`works.${tab.name}`)}
              </TabsTrigger>
            ))}
          </TabsList>

          <TabsContent value="web">
            <WebProjects theme={theme} />
          </TabsContent>

          <TabsContent value="mobile">
            <MobileProjects theme={theme} />
          </TabsContent>
        </Tabs> */}
        <WebProjects
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
      </section>
    </LayoutContainer>
  );
};

// 📌 Mobile Projects Component
const MobileProjects = () => {
  const { t } = useGlobalContext();
  const [loadingImg, setLoadingImg] = useState(true);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6">
      {mobileProjectsContent.map((project, idx) => (
        <WorkProject
          key={project.alt}
          {...project}
          loadingImg={loadingImg}
          setLoadingImg={setLoadingImg}
          t={t}
        />
      ))}
    </div>
  );
};

const WebProjects = () => {
  const { t } = useGlobalContext();
  const [loadingImg, setLoadingImg] = useState(true);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
      {projectsContent.map((project, idx) => (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: idx * 0.1 }}
          key={idx}
        >
          <WorkProject
            key={idx}
            loadingImg={loadingImg}
            setLoadingImg={setLoadingImg}
            t={t}
            ImgSrc={project.ImgSrc}
            alt={project.alt}
            projectUrl={project.projectUrl}
            hoverMsg={project.hoverMsg}
            projectTitle={project.projectTitle}
            ProjectDes={project.ProjectDes}
            gitUrl={project.gitUrl}
            projectTechStack={project.projectTechStack}
            isPrivate={project.isPrivate}
            platform={project.platform}
          />
        </motion.div>
      ))}
    </div>
  );
};

// 📌 Work Project Component

const WorkProject = ({
  loadingImg,
  setLoadingImg,
  t,
  ImgSrc,
  alt,
  projectUrl,
  hoverMsg,
  projectTitle,
  ProjectDes,
  gitUrl,
  projectTechStack,
  isPrivate,
  platform
}) => {
  return (
    <Card className="w-full flex flex-col h-[490px] rounded-lg overflow-hidden transition-all ">
      {/* Project Image */}
      <div className="relative group h-[290px] w-full overflow-hidden bg-gray-100 dark:bg-gray-900 flex items-center justify-center">
        {loadingImg && <Loader />}
        <img
          src={ImgSrc}
          alt={alt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          onLoad={() => setLoadingImg(false)}
        />
        {/* Overlay on Hover */}
        <a
          href={projectUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="absolute inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500"
        >
          <span className="text-white text-lg font-semibold flex items-center gap-2 transform group-hover:scale-105 transition-transform">
            {t(`works.${hoverMsg}`)} <Eye />
          </span>
        </a>
      </div>

      {/* Project Details */}
      <CardContent className="flex flex-col flex-1 p-5 min-h-[270px] dark:bg-gray-800 text-black dark:text-white  gap-3">
        <CardHeader className="p-0 mb-2 flex flex-row gap-3 items-center align-middle">
          <CardTitle className="text-lg font-semibold line-clamp-1">
            {t(`works.${projectTitle}`)}
          </CardTitle>
        </CardHeader>

        {/* Description */}
        <p className="text-sm text-gray-600 dark:text-gray-400 line-clamp-3 flex-1 min-h-12">
          {t(`works.${ProjectDes}`)}
        </p>

        {/* Tech Stack */}
        <div className="flex flex-wrap gap-2 mt-3 h-12">
          {projectTechStack.map((tech, idx) => (
            <span
              key={idx}
              className="px-3 py-1 text-xs font-medium bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-300 rounded-full transition-colors duration-300 hover:bg-primary hover:text-white"
            >
              {tech}
            </span>
          ))}
        </div>

        {/* Buttons */}
        <div className="flex justify-between items-center mt-auto pt-4">
          <div></div>
          {isPrivate ? (
            <Button
              variant="outline"
              disabled
              className="opacity-50 cursor-not-allowed"
            >
              <GithubIcon size={20} />
            </Button>
          ) : (
            <Button
              variant="outline"
              asChild
              className="transition-transform hover:scale-110"
            >
              <a
                href={gitUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2"
              >
                <GithubIcon size={20} />
              </a>
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

const GithubIcon = ({ size = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    width={size}
    height={size}
  >
    <path d="M12 2C6.48 2 2 6.48 2 12c0 4.42 2.87 8.17 6.84 9.49.5.09.66-.21.66-.47 0-.23-.01-.84-.01-1.65-2.79.61-3.38-1.34-3.38-1.34-.45-1.15-1.1-1.46-1.1-1.46-.9-.62.07-.6.07-.6 1 .07 1.53 1.02 1.53 1.02.89 1.53 2.33 1.09 2.9.83.09-.64.35-1.09.64-1.34-2.22-.26-4.56-1.11-4.56-4.94 0-1.09.39-1.99 1.03-2.69-.1-.26-.45-1.29.1-2.69 0 0 .84-.27 2.75 1.03a9.55 9.55 0 0 1 5 0c1.9-1.3 2.75-1.03 2.75-1.03.55 1.4.2 2.43.1 2.69.64.7 1.03 1.6 1.03 2.69 0 3.84-2.34 4.68-4.57 4.94.36.31.68.91.68 1.84 0 1.33-.01 2.4-.01 2.73 0 .26.16.56.67.47A10.02 10.02 0 0 0 22 12c0-5.52-4.48-10-10-10Z" />
  </svg>
);


